<script lang="ts" setup>
import { PropType, ref, watch } from "vue";
import QRCodeCanvas from "@/components/atoms/other/QRCodeCanvas.vue";

const props = defineProps({
  isVisible: {
    type: Boolean,
    required: true
  },
  closeModal: {
    type: Function as PropType<() => void>,
    required: true
  },
  appInstallationPortalURL: {
    type: Function as PropType<() => string>,
    required: true
  },
  qrCodeLib: {
    type: Object as PropType<{
      toCanvas: (canvas: HTMLCanvasElement, url: string) => Promise<void>;
    }>,
    required: true
  }
});

const reactiveVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  toggled => {
    reactiveVisible.value = toggled;
  }
);
</script>

<template>
  <BModal
    id="application-installation-guiding-modal-container"
    v-model="reactiveVisible"
    @hide="closeModal"
    hide-footer
    hide-header
    centered
  >
    <div class="qr-code-modal-content">
      <img src="@/assets/svg/google_for_jobs_qr_placeholder.svg?webp" />
      <QRCodeCanvas
        :url-provider="appInstallationPortalURL"
        :qr-code-lib="props.qrCodeLib"
        class="qr-code-canvas"
      />
    </div>
  </BModal>
</template>

<style lang="scss">
// BModalによってデフォルトのバックグラウンドが表示されてしまい、
// 描画したsvgからはみ出て白い矩形がチラ見えするのでそれを隠す。
// scopedにすると一切のコントロールが効かなくなるため、
// idによる一意性を担保した上でglobal styleとして定義する。
#application-installation-guiding-modal-container .modal-content {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
</style>

<style scoped lang="scss">
.qr-code-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

// QRコードをプレースホルダSVGの上にオーバーレイする
.qr-code-modal-content .qr-code-canvas {
  position: absolute;
  top: 98px;
  left: 395px;
  pointer-events: none;
  transform: scale(1.4);
}
</style>
